export default "__VITE_ASSET__CG8TB8ev__"